module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/login-pass/~/axios/index.js
 ** module id = 2093
 ** module chunks = 30 33 69 71
 **/